var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7367 15.2978C31.9064 15.7505 31.9064 16.2495 31.7367 16.7022L31.084 18.4425C29.7045 22.1213 27.7155 25.5414 25.2003 28.5597L24.5052 29.3937C24.1806 29.7833 23.7201 30.035 23.2169 30.0979L20.3412 30.4573C17.4583 30.8177 14.5417 30.8177 11.6588 30.4573L8.78312 30.0979C8.27992 30.035 7.8194 29.7833 7.49475 29.3937L6.79973 28.5597C4.28453 25.5414 2.29547 22.1213 0.915953 18.4425L0.263342 16.7022C0.093553 16.2495 0.0935531 15.7505 0.263342 15.2978L0.915953 13.5575C2.29547 9.87874 4.28453 6.45856 6.79973 3.44032L7.49475 2.60629C7.8194 2.21671 8.27992 1.96501 8.78313 1.90211L11.6588 1.54265C14.5417 1.18229 17.4583 1.18229 20.3412 1.54265L23.2169 1.90211C23.7201 1.96501 24.1806 2.21672 24.5052 2.6063L25.2003 3.44033C27.7155 6.45857 29.7045 9.87874 31.084 13.5575L31.7367 15.2978Z",
    fill: "#589FE0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.7367 15.2978C31.9064 15.7505 31.9064 16.2495 31.7367 16.7022L31.084 18.4425C29.7045 22.1213 27.7155 25.5414 25.2003 28.5597L24.5052 29.3937C24.1806 29.7833 23.7201 30.035 23.2169 30.0979L20.3412 30.4573C17.4583 30.8177 14.5417 30.8177 11.6588 30.4573L8.78312 30.0979C8.27992 30.035 7.8194 29.7833 7.49475 29.3937L6.79973 28.5597C4.28453 25.5414 2.29547 22.1213 0.915953 18.4425L0.263342 16.7022C0.093553 16.2495 0.0935531 15.7505 0.263342 15.2978L0.915953 13.5575C2.29547 9.87874 4.28453 6.45856 6.79973 3.44032L7.49475 2.60629C7.8194 2.21671 8.27992 1.96501 8.78313 1.90211L11.6588 1.54265C14.5417 1.18229 17.4583 1.18229 20.3412 1.54265L23.2169 1.90211C23.7201 1.96501 24.1806 2.21672 24.5052 2.6063L25.2003 3.44033C27.7155 6.45857 29.7045 9.87874 31.084 13.5575L31.7367 15.2978Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.18,
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.5,
    y1: 27,
    x2: 6.5,
    y2: 3.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.9e2c1d6a0238a48201fba87a2924042d.svg";
export { ForwardRef as ReactComponent };